interface Params {
    hasWeightOptions: boolean
    hasColorOptions: boolean
    hasAtleastOneWeightUnit: boolean
}

export const generateVariantErrorMessage = ({ hasWeightOptions, hasColorOptions, hasAtleastOneWeightUnit }: Params) => {
    const unitLabel = hasAtleastOneWeightUnit ? 'وزن' : 'سایز'

    if (hasWeightOptions && hasColorOptions) return `ابتدا ${unitLabel} و رنگ مورد نظر را انتخاب کنید.`
    if (hasWeightOptions) return `ابتدا یک ${unitLabel} انتخاب کنید.`
    if (hasColorOptions) return 'ابتدا یک رنگ انتخاب کنید.'
    return ''
}
